exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".spesa-item .v-list__tile{height:auto!important}.spesa-item .v-list__tile .v-list__tile__sub-title{white-space:normal}.spesa-item .spesa-verify__btn{display:none}.spesa-item:hover{cursor:pointer}.spesa-item:hover .spesa-verify__btn{display:flex}.dettaglio-list .v-list__tile{height:auto!important}.scroll__container{height:70vh}.spesa-dettaglio .container__wrap{height:50vh}.spesa-dettaglio .spesa-dettaglio__toolbar .v-toolbar__content{justify-content:center}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib??vue-loader-options!./modules/Home/views/src/components/TabVerificaNote.vue?vue&type=style&index=0&lang=scss&
// module id = 826
// module chunks = 0